/*
  R9 (2026-08-29) — atalhos de detalhe dentro do ZOOM da galeria.

  Insight do Rodrigo: o zoom é o momento em que o cliente quer inspecionar o
  produto de perto. Então é ali que devem aparecer os atalhos "Veio da madeira"
  e "Trama do tecido" — que abrem os modais macro que JÁ existem no configurador
  (botões [data-r9sw-open="wood"|"fabric"]). Nada de conteúdo novo: só a porta
  certa no lugar certo.

  Implementação sem tocar no bloco nativo da galeria: um observador global vê o
  <dialog> do zoom abrir (inclusive o que chega novo após a troca suave de cor)
  e injeta a barra de pílulas. Clique: fecha o zoom e clica o gatilho
  correspondente do configurador — na instância VISÍVEL (mobile/desktop têm
  instâncias separadas; a escondida não renderiza o modal).

  Se a página não tem configurador (produto sem grupo), a barra não aparece.
*/
(function () {
  if (window.__r9ZoomAtalhos) return;
  window.__r9ZoomAtalhos = true;

  var CSS_ID = 'r9-zoom-atalhos-css';

  function injetarCss() {
    if (document.getElementById(CSS_ID)) return;
    var s = document.createElement('style');
    s.id = CSS_ID;
    s.textContent =
      '.r9-zoom-atalhos{position:absolute;left:50%;transform:translateX(-50%);bottom:16px;' +
      'display:flex;gap:8px;z-index:6;pointer-events:auto;}' +
      '.r9-zoom-atalhos__btn{display:inline-flex;align-items:center;gap:7px;min-height:44px;' +
      'padding:10px 16px;border:1px solid rgba(255,255,255,.34);border-radius:999px;' +
      'background:rgba(36,29,21,.72);color:#fff;font:600 12.5px/1 inherit;letter-spacing:.02em;' +
      'white-space:nowrap;cursor:pointer;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);}' +
      '.r9-zoom-atalhos__btn:hover{background:rgba(36,29,21,.88);}' +
      '.r9-zoom-atalhos__btn svg{flex:none;}' +
      '@media screen and (max-width: 749px){.r9-zoom-atalhos{bottom:120px;}}';
    (document.head || document.documentElement).appendChild(s);
  }

  var ICONE_OLHO =
    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12Z"/><circle cx="12" cy="12" r="2.6"/></svg>';

  /*
    Ida e VOLTA (ajuste 29/08, pedido do Rodrigo): quem chegou ao macro pelo zoom
    deve voltar ao zoom ao fechar o macro — no mesmo slide. Guardamos o componente
    e o índice ativo ao sair; quando o macro fechar (botão Fechar, fundo ou Esc),
    reabrimos com zoomComp.open(idx). Validade curta para nunca reabrir por engano.
  */
  var retorno = null;

  function indiceAtivo(dialog) {
    var thumbs = dialog.querySelectorAll('.dialog-thumbnails-list button');
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].getAttribute('aria-selected') === 'true') return i;
    }
    return 0;
  }

  function reabrirZoom() {
    if (!retorno || Date.now() - retorno.t > 300000) { retorno = null; return; }
    var dado = retorno;
    retorno = null;
    setTimeout(function () {
      // comp.open(idx) exige o event do clique (usa preventDefault) — reabrimos pelo
      // caminho oficial: o clique na própria mídia daquele índice.
      var alvos = document.querySelectorAll('media-gallery .product-media-container');
      var alvo = alvos[dado.idx] || alvos[0];
      if (alvo) { alvo.click(); return; }
      var btns = document.querySelectorAll('media-gallery .product-media-container__zoom-button');
      if (btns[dado.idx]) btns[dado.idx].click();
      else if (btns[0]) btns[0].click();
    }, 80);
  }

  // fechar do macro por clique: botão "Fechar" ou o fundo escuro (o backdrop é o
  // próprio [data-r9sw-modal]) — capture, para rodar mesmo com stopPropagation
  document.addEventListener(
    'click',
    function (ev) {
      if (!retorno) return;
      if (ev.target.closest && ev.target.closest('[data-r9sw-close]')) { reabrirZoom(); return; }
      if (ev.target.hasAttribute && ev.target.hasAttribute('data-r9sw-modal')) reabrirZoom();
    },
    true
  );

  // fechar do macro por Esc: só conta se havia um macro aberto neste instante
  document.addEventListener(
    'keydown',
    function (ev) {
      if (ev.key !== 'Escape' || !retorno) return;
      var aberto = Array.prototype.some.call(
        document.querySelectorAll('[data-r9sw-modal]'),
        function (m) { return !m.hidden; }
      );
      if (aberto) reabrirZoom();
    },
    true
  );

  function gatilhoVisivel(tipo) {
    var todos = document.querySelectorAll('[data-r9sw-open="' + tipo + '"]');
    var visivel = null;
    todos.forEach(function (el) {
      if (!visivel && el.getBoundingClientRect ) {
        var raiz = el.closest('.r9sw');
        if (raiz && getComputedStyle(raiz).display !== 'none') visivel = el;
      }
    });
    return visivel || todos[0] || null;
  }

  function montarBarra(dialog) {
    if (dialog.querySelector('.r9-zoom-atalhos')) return;
    var madeira = gatilhoVisivel('wood');
    var tecido = gatilhoVisivel('fabric');
    if (!madeira && !tecido) return;

    injetarCss();
    var barra = document.createElement('div');
    barra.className = 'r9-zoom-atalhos';

    function botao(rotulo, gatilho) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'r9-zoom-atalhos__btn';
      b.innerHTML = ICONE_OLHO + rotulo;
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        retorno = { idx: indiceAtivo(dialog), t: Date.now() };
        var fechar = dialog.querySelector('.dialog-zoomed-gallery__close-button');
        if (fechar) fechar.click();
        else if (dialog.close) dialog.close();
        setTimeout(function () {
          var g = gatilhoVisivel(gatilho);
          if (g) g.click();
        }, 120);
      });
      return b;
    }

    if (madeira) barra.appendChild(botao('Veio da madeira', 'wood'));
    if (tecido) barra.appendChild(botao('Trama do tecido', 'fabric'));
    dialog.appendChild(barra);
  }

  // observa qualquer <dialog> de zoom abrindo (inclusive os que chegam após a
  // troca suave de cor, que substitui a galeria inteira)
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      if (m.type === 'attributes' && m.attributeName === 'open') {
        var d = m.target;
        if (d instanceof HTMLDialogElement && d.hasAttribute('open') && d.closest('zoom-dialog')) {
          montarBarra(d);
        }
      }
    });
  });
  mo.observe(document.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });
})();
